import { render } from "./ColorBackgroundPage.vue?vue&type=template&id=e19f4830&ts=true"
import script from "./ColorBackgroundPage.vue?vue&type=script&lang=ts"
export * from "./ColorBackgroundPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__